import GroupsIcon from "@mui/icons-material/Groups";
import AddIcon from "@mui/icons-material/Add";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { SoftButton, SoftFooter, SoftRowSkeleton, cls } from "../../hatim/soft/SoftKit";

/**
 * Sol sütun: yönettiğin gruplar. Hatimleri Yönet listesiyle aynı düzen:
 * üstte sabit açık özet şeridi, çizgiyle ayrılmış satırlar, altta sabit
 * "Yeni Grup". Koyu temada da uyumlu.
 */
export default function GroupListPanel({ groups, selectedId, loading, onSelect, onCreate }) {
  const { t } = useScriptMode();

  return (
    <div
      className={`${cls.panel} overflow-hidden flex flex-col min-h-[320px] max-h-[calc(100vh-3rem)] lg:h-full lg:max-h-full lg:min-h-0`}
    >
      <div className={`shrink-0 flex items-center gap-3 px-4 py-3 ${cls.summary}`}>
        <span className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${cls.avatar}`}>
          <GroupsIcon sx={{ fontSize: 20 }} aria-hidden />
        </span>
        <div className="min-w-0 flex-1">
          <div className={`text-lg font-SemiBold leading-tight ${cls.heading}`}>{t("nav_groups")}</div>
          <div className={`text-xs leading-tight ${cls.muted}`}>
            {groups.length} {t("groups_count_suffix")}
          </div>
        </div>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto">
        {loading ? (
          <SoftRowSkeleton rows={4} />
        ) : groups.length === 0 ? (
          <div className="text-center py-10 px-4">
            <GroupsIcon sx={{ fontSize: 32 }} className={cls.faint} aria-hidden />
            <p className={`text-base mt-3 ${cls.muted}`}>{t("groups_manage_empty")}</p>
          </div>
        ) : (
          <ul className="tk-stagger">
            {groups.map((group) => {
              const active = String(group.id) === String(selectedId);
              return (
                <li key={group.id}>
                  <button
                    type="button"
                    data-group={group.id}
                    aria-pressed={active}
                    onClick={() => onSelect(String(group.id))}
                    className={[
                      "w-full text-left flex items-center gap-3 px-4 py-3 transition-colors",
                      cls.row,
                      active ? "bg-terakkiBrandCloud dark:bg-white/[0.08]" : cls.rowHover,
                    ].join(" ")}
                  >
                    <span
                      className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${cls.avatar}`}
                    >
                      <GroupsIcon sx={{ fontSize: 18 }} aria-hidden />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className={`block text-base font-SemiBold truncate ${cls.title}`}>
                        {group.groupName}
                      </span>
                      <span className={`block text-xs mt-0.5 truncate ${cls.muted}`}>
                        {group.memberCount} {t("groups_member_count")} · {group.totalManagers}{" "}
                        {t("groups_manager_count")}
                      </span>
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </div>

      <SoftFooter>
        <SoftButton tone="primary" fullWidth startIcon={<AddIcon fontSize="small" />} onClick={onCreate}>
          {t("groups_create_cta")}
        </SoftButton>
      </SoftFooter>
    </div>
  );
}
